import RichTextWrapper from "./RichTextWrapper";
export default RichTextWrapper;
